import React from "react";
import { Typography } from "@mui/material";
import { AppTextField } from "./ui";
import "./WorldUnitEditor.scss";

const unitOptions = [
  { value: 0, label: "fm" },
  { value: 1, label: "pm" },
  { value: 2, label: "A" },
  { value: 3, label: "nm" },
  { value: 4, label: "um" },
  { value: 5, label: "mm" },
  { value: 6, label: "cm" },
  { value: 7, label: "m" },
  { value: 8, label: "km" },
  { value: 9, label: "Mm" },
  { value: 10, label: "Gm" },
  { value: 11, label: "Tm" },
  { value: 12, label: "Pm" },
  { value: 13, label: "Em" },
  { value: 14, label: "parsec" },
  { value: 15, label: "megaParsec" },
  { value: 16, label: "lightYear" },
  { value: 17, label: "None" },
];

const WorldUnitEditor = ({ worldUnit = {}, onChange }) => (
  <div className="world-unit-editor">
    <div className="world-unit-editor__panel">
      <div className="world-unit-editor__row">
        <Typography variant="subtitle1" className="world-unit-editor__title">
          World Unit:
        </Typography>
        <div className="world-unit-editor__fields">
          <div className="world-unit-editor__field">
            <AppTextField
              label="Value"
              value={worldUnit.value ?? ""}
              onChange={(e) => onChange("value", e.target.value)}
              size="small"
              fullWidth
            />
          </div>
          <div className="world-unit-editor__field">
            <AppTextField
              select
              label="Unit"
              value={worldUnit.units ?? 17}
              onChange={(e) => onChange("units", parseInt(e.target.value, 10))}
              size="small"
              SelectProps={{ native: true }}
              fullWidth
            >
              {unitOptions.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </AppTextField>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WorldUnitEditor;
